import { render, staticRenderFns } from "./CubeOptions.vue?vue&type=template&id=25e53d68"
import script from "./CubeOptions.vue?vue&type=script&lang=js"
export * from "./CubeOptions.vue?vue&type=script&lang=js"
import style0 from "./CubeOptions.vue?vue&type=style&index=0&id=25e53d68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports